import Vue from 'vue'

import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Interceptors from './interceptors/index'
import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);
import "vuetify-dialog/dist/vuetify-dialog.min.css";
import './styles/style.css'
import OAuth from './oauth'
import VuetifyDialog from 'vuetify-dialog'
import Error from "./components/Errors";
import ExportButton from "./components/ExportButton";

import * as VueGoogleMaps from 'vue2-google-maps'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCpb54b8FB5WVxBDKAYVknsOZWGYNn0V74',
        libraries: 'places,directions', // This is required if you use the Autocomplete plugin
    },
});
import vuetify from '@/plugins/vuetify'
import './registerServiceWorker'
//
Vue.use(VuetifyDialog, {
    context: {
        vuetify
    }
});


Vue.config.productionTip = false;
Vue.use(Interceptors);
Vue.prototype.$oauth = new OAuth();
Vue.use(VuetifyDialog);
Vue.component(
    'error', Error
);
Vue.component('export-button', ExportButton)


Vue.loadScript("https://cdn.jsdelivr.net/npm/jsprintmanager")
    .then(() => {
            // Script is loaded, do something
    })
    .catch(() => {
        console.log('failed to load - https://cdn.jsdelivr.net/npm/jsprintmanager')

        // Failed to fetch script
    });

Vue.loadScript("https://cdn.jsdelivr.net/npm/jsprintmanager")
    .then(() => {
        Vue.loadScript("https://jsprintmanager.azurewebsites.net/scripts/zip-ext.js")
            .then(() => {
                // Script is loaded, do something
            })
            .catch(() => {
                console.log('failed to load - https://jsprintmanager.azurewebsites.net/scripts/zip-ext.js')
                // Failed to fetch script
            });
        // Script is loaded, do something
    })
    .catch(() => {
        console.log('failed to load - https://jsprintmanager.azurewebsites.net/scripts/zip.js')
            // Failed to fetch script
    });

Vue.loadScript("hhttps://cdn.jsdelivr.net/npm/jsprintmanager")
    .then(() => {
        // Script is loaded, do something
    })
    .catch(() => {
        console.log('failed to load - https://cdn.jsdelivr.net/npm/jsprintmanager')
            // Failed to fetch script
    });




new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
